var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoutMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.69631 0H14.0889C15.3345 0 16.529 0.482424 17.4097 1.34114C18.2904 2.19986 18.7852 3.36454 18.7852 4.57895V10.6842H17.2198V4.57895C17.2198 3.76934 16.8899 2.99289 16.3028 2.42041C15.7156 1.84793 14.9193 1.52632 14.0889 1.52632H4.69631C3.86595 1.52632 3.0696 1.84793 2.48245 2.42041C1.89529 2.99289 1.56544 3.76934 1.56544 4.57895V24.4211C1.56544 25.2307 1.89529 26.0071 2.48245 26.5796C3.0696 27.1521 3.86595 27.4737 4.69631 27.4737H14.0889C14.9193 27.4737 15.7156 27.1521 16.3028 26.5796C16.8899 26.0071 17.2198 25.2307 17.2198 24.4211V18.3158H18.7852V24.4211C18.7852 25.6355 18.2904 26.8001 17.4097 27.6589C16.529 28.5176 15.3345 29 14.0889 29H4.69631C3.45077 29 2.25624 28.5176 1.37552 27.6589C0.494788 26.8001 0 25.6355 0 24.4211V4.57895C0 3.36454 0.494788 2.19986 1.37552 1.34114C2.25624 0.482424 3.45077 0 4.69631 0V0ZM9.39261 13.7368H27.0038L21.9161 8.77632L22.9555 7.63158L30 14.5L22.9555 21.3684L21.9161 20.2237L27.0038 15.2632H9.39261V13.7368Z",
    fill: "url(#paint0_linear_364_103)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_364_103",
    x1: -2.64499e-7,
    y1: 14.1081,
    x2: 30,
    y2: 14.1081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A01F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4536C"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutMobile);
export default __webpack_public_path__ + "static/media/logout_mobile.66149b66.svg";
export { ForwardRef as ReactComponent };